import * as React from 'react';
import * as I18n from 'i18n-js';
import {
  IOfferLocation,
} from './negotiation_types';
import FormGroupWithInput from '../components/form_group_with_input';
import ShippingRegionSelector from './shipping_region_selector';
import { core_apimessages_Country as ICountry } from '../rql';
import { shippingRegionName } from './shipping_region';

interface IProps {
  isEditing: boolean;
  countries: ICountry[];
  location: IOfferLocation;
  onLocationChange: (location: Partial<IOfferLocation>) => void;
  onEditLocation: () => void;
}

function renderClosed(props: IProps) {
  const label = I18n.t('commons.offers.location.shippingTo', {
    regionName: shippingRegionName(props.location.shippingRegionCode, props.countries),
    postalCode: props.location.postalCode,
  });

  return (
    <p className="offers-form__location-text">
      {label}
      <button
        className="offers-form__location__edit"
        onClick={props.onEditLocation}
      >
        {I18n.t('commons.offers.location.change')}
      </button>
    </p>
  );
}

function renderOpen(props: IProps) {
  return (
    <div className="offers-form__location__form">
      <div className="offers-form__location__input">
        <ShippingRegionSelector
          countries={props.countries}
          onChange={props.onLocationChange}
          value={props.location.shippingRegionCode}
        />
      </div>
      <div className="offers-form__location__input">
        <FormGroupWithInput
          label={I18n.t('commons.offers.location.postalCodeLabel')}
          fieldName="postalCode"
          inputName="postalCode"
          value={props.location.postalCode}
          updateField={props.onLocationChange}
          required
        />
      </div>
    </div>
  );
}

const LocationForm: React.SFC<IProps> = (props: IProps) => (
  props.isEditing ? renderOpen(props) : renderClosed(props)
);

export default LocationForm;
